import id from './{id}';
import query from './query';
import get from './get';
import post from './post';

type ActivationConfigType = {
  autoActivate?: boolean;
  autoCreate?: boolean;
  changeNodeType?: boolean;
  changeParent?: boolean;
  setParent?: 'parent' | 'self';
  syncParentFolder?: boolean;
};

export type PostPayload = {
  activationConfig?: ActivationConfigType;
  allowedRoles?: number[];
  channels?: number[];
  driverId?: number;
  name: string;
  vanityName: string;
};
export default { id, query, get, post };
